// extracted by mini-css-extract-plugin
export default {"miniShell":"Branding_miniShell__qRDAE","miniSide":"Branding_miniSide__AQNge","miniLogo":"Branding_miniLogo__boAkp","miniMain":"Branding_miniMain__5t+89"};